export default (props, vars) =>
  vars?.['useform1']?.['register']('yourTitle', { required: true });
